import { render, staticRenderFns } from "./RoleDashboardRedirect.vue?vue&type=template&id=44c0e140&"
import script from "./RoleDashboardRedirect.vue?vue&type=script&lang=js&"
export * from "./RoleDashboardRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports